export default __webpack_public_path__ + "images/5b812f07e3901f24bf83d24f6d935c04-results_bar.svg";